import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { isRecommendationType } from '../../../spacesPlatform/models/ContentType';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { IViewInfo } from '../../../ts/models/IViewInfo';
import { EntityLinkProps } from './Elements/EntityLink';
import { LocationField } from './Elements/LocationField';
import { Name } from './Elements/Name';
import { Recommendation } from './Elements/Recommendation';
import { RelatedEntity } from './Elements/RelatedEntity';
import { Tags } from './Elements/Tags';
import { Timestamp } from './Elements/Timestamp';
import { doesTooltipNotHaveOwnerToDisplay,Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, getPersonalSpaceLink,getProjectLink, TooltipDescriptionTestId } from './TooltipHelper';

export function isViewTooltipContentUnfocusable(content: IContentInfo) {
  return !content ||
    (!(content as IViewInfo).workbook || (doesTooltipNotHaveOwnerToDisplay(content)));
}

export function ViewTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;

  // Views api does not return owner property at the top level, but rather adds to the workbook
  const workbook = (content as IViewInfo).workbook;
  const owner: IUserInfo = content.owner || (workbook && workbook.owner);
  const workbookLink: EntityLinkProps = workbook ? {
    href: urls.workbookUrl(workbook.id),
    iconImagePath: imgPath('workbook_content_type_small.svg'),
    iconHeightOverride: 18,  // the icon height is 18 just for workbooks :|
    name: workbook.name
  } : null;

  const projectLink = workbook ? getProjectLink(workbook.project, urls) : null;
  const personalSpaceLink = getPersonalSpaceLink(urls);
  const locationType = workbook?.location?.type;
  const ownerId = owner?.id;
  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      {isRecommendationType(props.content.contentType) && <Recommendation explanationType={content.explanationType} users={content.similiarUsers} urls={urls}/>}
      <Tags tags={content.tags} />
      { workbook && <RelatedEntity label={Messages.workbook()} link={workbookLink} /> }
      {!FeatureFlags.personalSpaceEnabled && !props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} /> }
      {FeatureFlags.personalSpaceEnabled && <LocationField inProjectSpace={props.inProjectSpace} inPersonalSpace={props.inPersonalSpace}
        locationType={locationType} projectLink={projectLink} personalSpaceLink={personalSpaceLink} contentOwnerId={ownerId}/>}
      { owner && <User user={owner} label={Messages.owner()} urls={urls} /> }
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
